module.exports = __webpack_public_path__ + "static/img/酷e宝.ff4cbb28.png";